import React, { useEffect, useState, forwardRef } from "react";
import PropTypes from "prop-types";
import { ErrorMessage, Field } from "formik";
import LinkIcon from "@material-ui/icons/Link";
import styles from "./Upload.module.scss";
import { getLocalORPublicSrc } from "../../utils/Constants";

const Upload = forwardRef(
  (
    {
      onChange,
      label,
      name,
      setFieldValue,
      accept,
      handlePreviewSrc,
      isShowName,
      isRequired,
      initialFileData,
      disabled,
      isMultiple
    },
    ref
  ) => {
    const [fileData, setFileData] = useState({});

    useEffect(() => {
      if (initialFileData) {
        setFileData({ ...fileData, ...initialFileData });
      }
    }, [initialFileData?.link]);

    const handleChange = (event) => {
      const files = event.target.files;
      if (files.length) {
        setFieldValue(name, isMultiple ? files : files[0]);

        if (isMultiple) {
          const filesAsArray = [...files];
          let filesSrc = [];
          filesAsArray.forEach((file) => {
            filesSrc.push(URL.createObjectURL(file));
          });
          handlePreviewSrc(filesSrc);
        } else {
          const file = files[0];
          const src = URL.createObjectURL(file);
          console.log("src", src);

          handlePreviewSrc(src);
          setFileData({
            isLinkLocal: true,
            link: src,
            name: file.name
          });
        }
      }
    };

    const getFileName = (path) =>
      path?.split("/").pop()?.replace(/^\d+_/, "");

    const isBookPdf = fileData.type === "book_pdf";
    const href = !isBookPdf
      ? getLocalORPublicSrc(fileData?.link)
      : fileData?.isLinkLocal
      ? fileData?.link
      : undefined;

    return (
      <div className={styles.wrapper}>
        <Field name={name}>
          {() => (
            <>
              <input
                ref={ref} // Forward the ref to this input
                className="d-none"
                name={name}
                id={name}
                type="file"
                accept={accept}
                disabled={disabled}
                multiple={isMultiple}
                onChange={onChange || handleChange}
              />
              <label
                className={`${styles.label} ${
                  disabled ? styles.disabled : ""
                }`}
                htmlFor={name}
              >
                {label}{" "}
                {isRequired && (
                  <span className="error-msg fsize-14">*</span>
                )}
              </label>
              {isShowName && fileData?.name && (
                <a
                  href={href}
                  target={href ? "_blank" : undefined}
                  rel="noreferrer"
                  style={{ pointerEvents: href ? "auto" : "none" }}
                  className="fsize-14 mx-2 text-break text-primary"
                >
                  <LinkIcon style={{ marginRight: "2px" }} />
                  {fileData?.isLinkLocal
                    ? fileData.name
                    : getFileName(fileData?.link)}
                </a>
              )}
            </>
          )}
        </Field>
        <ErrorMessage
          component="div"
          className="error-msg"
          name={name}
        />
      </div>
    );
  }
);

Upload.propTypes = {
  onChange: PropTypes.func,
  label: PropTypes.string,
  name: PropTypes.string,
  setFieldValue: PropTypes.func,
  accept: PropTypes.string,
  handlePreviewSrc: PropTypes.func,
  isShowName: PropTypes.bool,
  isRequired: PropTypes.bool,
  initialFileData: PropTypes.object,
  disabled: PropTypes.bool,
  isMultiple: PropTypes.bool
};

Upload.defaultProps = {
  label: "Upload",
  accept: "",
  isShowName: false,
  isRequired: false,
  initialFileData: {},
  disabled: false,
  isMultiple: false,
  onChange: null,
  setFieldValue: () => {},
  handlePreviewSrc: () => {}
};

export default Upload;
